(() => {
  const SELECTOR = '[data-om-card-variant-select]';
  const FORM_SELECTOR = '.om-card-variant-form';
  const TOAST_ID = 'om-card-selection-toast';

  let toastTimer;

  function getOrCreateToast() {
    let toast = document.getElementById(TOAST_ID);

    if (toast) {
      return toast;
    }

    toast = document.createElement('div');
    toast.id = TOAST_ID;
    toast.className = 'om-card-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');

    document.body.appendChild(toast);

    return toast;
  }

  function showToast(message) {
    const toast = getOrCreateToast();

    window.clearTimeout(toastTimer);

    toast.textContent = message;
    toast.classList.add('is-visible');

    toastTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  function highlightSelector(select) {
    const wrapper = select.closest('.om-card-select-wrap');

    if (!wrapper) {
      return;
    }

    wrapper.classList.remove('is-attention');

    // Restart the visual transition if tapped repeatedly.
    void wrapper.offsetWidth;

    wrapper.classList.add('is-attention');

    window.setTimeout(() => {
      wrapper.classList.remove('is-attention');
    }, 1400);
  }

  function getSelectionState(select) {
    const selectedOption = select.options[select.selectedIndex];

    const hasSelectedVariant = Boolean(
      select.value &&
      selectedOption &&
      !selectedOption.disabled
    );

    const hasAvailableVariant = Array.from(select.options).some(
      (option) => option.value && !option.disabled
    );

    return {
      hasSelectedVariant,
      hasAvailableVariant
    };
  }

  function syncCardForm(select) {
    const form = select.closest('form');

    if (!form) {
      return;
    }

    const button = form.querySelector('[data-om-card-submit]');

    if (!button) {
      return;
    }

    const { hasSelectedVariant, hasAvailableVariant } =
      getSelectionState(select);

    if (!hasAvailableVariant) {
      // A genuinely sold-out product remains truly disabled.
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.classList.remove('is-awaiting-selection');
      return;
    }

    // Available products stay tappable, even before a size is chosen.
    button.disabled = false;
    button.setAttribute(
      'aria-disabled',
      hasSelectedVariant ? 'false' : 'true'
    );

    button.classList.toggle(
      'is-awaiting-selection',
      !hasSelectedVariant
    );
  }

  function initialiseCardForms(root = document) {
    root.querySelectorAll(SELECTOR).forEach(syncCardForm);
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches(SELECTOR)) {
      return;
    }

    syncCardForm(event.target);
  });

  /*
   * Capture the submission before Dawn handles it.
   * If no size is selected, stop submission and show guidance.
   */
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (!form.matches(FORM_SELECTOR)) {
        return;
      }

      const select = form.querySelector(SELECTOR);

      if (!select) {
        return;
      }

      const { hasSelectedVariant } = getSelectionState(select);

      if (hasSelectedVariant) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      showToast('Please choose a size first');
      highlightSelector(select);
      select.focus({ preventScroll: true });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialiseCardForms();
    });
  } else {
    initialiseCardForms();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseCardForms(event.target);
  });
})();